import React from 'react';
import './Button.css';

// Button uses React.forwardRef and spreads all props so that Radix UI's
// asChild / Slot pattern works correctly. Without forwardRef + prop spread,
// DropdownMenuTrigger asChild cannot inject its onClick, ref, or aria-*
// attributes into the underlying <button> element, causing dropdowns to
// silently fail to open.
export const Button = React.forwardRef(function Button(
  {
    variant = 'primary',
    size = 'md',
    children,
    onClick,
    disabled = false,
    type = 'button',
    className = '',
    ...props
  },
  ref
) {
  return (
    <button
      ref={ref}
      type={type}
      className={`btn btn-${variant} btn-${size} ${className}`}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
});

Button.displayName = 'Button';

// Export buttonVariants for compatibility with shadcn components
export const buttonVariants = (variant = 'primary') => {
  return `btn btn-${variant}`;
};
